function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

docReady(doIt);
function doIt() {
  window.onWizzyScriptLoaded = function () {
    
    document.querySelector(".btn--close-search").addEventListener("click", function(event) {
      var x = document.querySelector(".site-header__search-container");
      if(x != null && x != undefined) {
        if(x.classList.contains("is-active")) {
          x.classList.remove("is-active");
        }else {
          x.classList.add("is-active");
        }
      }
    });


    document.body.addEventListener("click", function (event) {
      var target = event.target;
    
      if (target.classList.contains("wizzy-autocomplete-top-products-view-more")) {
        // var input = document.querySelector(".search__input");
        // var closestForm = input.closest("form");
        // if(closestForm) {
        //   closestForm.submit();
        // }

        document.querySelector(".btn--close-search").click();
        // window.location.href = "/pages/search?q=" + document.querySelector(".wizzy-search-input").value;
        // location.reload();
        // window?.baCurr?.refreshConversion();
      }
    
      if (target.classList.contains("wizzy-filters-mobile-entry") || target.classList.contains("wizzy-search-sort-wrapper")) {
        document.body.classList.add("wizzy-filters-opened");
      }
    
      if (target.classList.contains("wizzy-filters-bg") || target.classList.contains("wizzy-filters-close-btn") || target.classList.contains("wizzy-common-select-overlay")) {
        document.body.classList.remove("wizzy-filters-opened");
      }
    });
    
    
    let interval = setInterval(() => {
      if (window?.baCurr?.Currency) {
        document
          .querySelector(".currMovers")
          .addEventListener("click", function () {
            location.reload();
          });
        clearInterval(interval);
      }
    }, 100);
    
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        var current_currency = getCurrencyCode();
        console.log("===");
        payload.currency = current_currency;
        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (payload) {
        var x = document.querySelector(".site-header__search-container");

        if (x != null || x != undefined) {
          x.classList.remove("is-active");
        }
        var current_currency = getCurrencyCode();
        payload.currency = current_currency;
        return payload;
      }
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function (payload) {
        var current_currency = getCurrencyCode();
        payload.filters.currency = current_currency;
        return payload;
      }
    );
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
      function (payload) {
        if (payload.response) {
          window.wizzyConfig.store.currency =
            payload.response.payload.configs.currency;
        } else {
          window.wizzyConfig.store.currency =
            payload.payload.products.configs.currency;
        }
        return payload;
      }
    );
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (payload) {
        var current_currency = getCurrencyCode();
        const codes = {
          USD: "$",
          INR: "Rs. ",
          EUR: "€",
          AED: "Dhs. ",
          AUD: "$",
          BHD: "BD",
          CAD: "$",
          GBP: "£",
          BDT: "Tk ",
          HKD: "$",
          KWD: "KD",
          MYR: "RM",
          NZD: "$",
          OMR: "OMR",
          QAR: "QAR",
          SAR: "SR",
          SGD: "$",
        };
        const currency = {
          code: current_currency,
          symbol: codes[current_currency],
        };
        window.wizzyConfig.store.currency = currency;
        if (window?.baCurr?.Currency) {
          for (var i = 0; i < payload.length; i++) {
            payload[i].price = Math.floor(
              window?.baCurr?.Currency?.convert(
                payload[i].price,
                "INR",
                current_currency
              )
            );
            payload[i].sellingPrice = payload[i].sellingPrice.replace(",", "");
            payload[i].sellingPrice = Math.floor(
              window?.baCurr?.Currency?.convert(
                parseInt(payload[i].sellingPrice),
                "INR",
                current_currency
              )
            );
          }
        } else {
          for (var i = 0; i < payload.length; i++) {
            payload[i].price = Math.floor(
              window?.Currency?.convert(
                payload[i].price,
                "INR",
                current_currency
              )
            );
            payload[i].sellingPrice = payload[i].sellingPrice.replace(",", "");
            payload[i].sellingPrice = Math.floor(
              window?.Currency?.convert(
                parseInt(payload[i].sellingPrice),
                "INR",
                current_currency
              )
            );
          }
        }
        return payload;
      }
    );

    function getCurrencyCode() {
      if (JSON.parse(window.sessionStorage.getItem("bacurr_user_cur"))) {
        return JSON.parse(window.sessionStorage.getItem("bacurr_user_cur"));
      } else {
        return "INR";
      }
    }
  }
}